// @ts-check
/**
 * Get separated lists for given event list
 * @param {import('./interface').TMatchModel[]} events - list of events
 * @param {import('./interface').TMatchModel} match - match object
 * @param {number} maxEvents - max events
 */
export function getSelectEventLists(events, match, maxEvents) {
  let counter = 0;
  const sameTournament = [];
  const sameCategory = [];
  const sameSport = [];
  const otherEvents = [];
  for (let index = 0; index < events.length; index++) {
    if (counter > maxEvents) {
      break;
    }
    const event = events[index];
    if (event.matchId === match.matchId) {
      continue;
    }
    if (event.tournamentId === match.tournamentId) {
      sameTournament.push(event);
      counter += 1;
    } else if (event.categoryId === match.categoryId) {
      if (sameCategory.length < maxEvents) {
        sameCategory.push(event);
      }
    } else if (event.sportId === match.sportId) {
      if (sameSport.length < maxEvents) {
        sameSport.push(event);
      }
    } else {
      if (otherEvents.length < maxEvents) {
        otherEvents.push(event);
      }
    }
  }

  return { sameTournament, sameCategory, sameSport, otherEvents };
}

/**
 * Filter max events number of events from getSelectEventLists
 * @param {ReturnType<typeof getSelectEventLists>} liveMap - live map returned from getSelectEventLists
 * @param {import('./interface').TMatchModel} match - current match
 * @param {number} maxEvents - max event number
 */
export function getFilteredLiveEvents(liveMap, match, maxEvents) {
  const order = ['sameTournament', 'sameCategory'];
  if (match.isLiveMatch) {
    order.push('sameSport', 'otherEvents');
  }
  /** @type {import('./interface').TMatchModel[]} */
  const events = [];
  while (order.length > 0) {
    const key = order.shift();
    for (let index = 0; index < liveMap[key].length; index++) {
      const event = liveMap[key][index];
      events.push(event);
      if (events.length > maxEvents) {
        break;
      }
    }
    if (events.length > maxEvents) {
      break;
    }
  }

  return events;
}

/**
 * Get separated lists for given event list
 * @param {import('./interface').TMatchModel[]} events - list of events
 * @param {import('./interface').TMatchModel} match - match object
 */
export function getSelectEventsTournamentsMap(events, match) {
  const tournamentList = [];
  const tournamentMap = {};
  let eventsNum = 0;
  for (let index = 0; index < events.length; index++) {
    const event = events[index];
    const tKey = `${event.sportId}_${event.tournamentId}`;
    if (typeof tournamentMap[tKey] === 'undefined') {
      const tObj = {
        tournamentId: event.tournamentId,
        tournamentName: event.tournamentName,
        categoryName: event.categoryName,
        categoryId: event.categoryId,
        events: /** @type {import('./interface').TMatchModel[]}*/([]),
      };
      if (checkSport(match, event, events[index - 1])) {
        tObj.sportName = event.sportName || event.sportsName;
        tObj.sportId = event.sportId;
      }
      tournamentList.push(tObj);
      tournamentMap[tKey] = tournamentList.length - 1;
    }
    tournamentList[tournamentMap[tKey]].events.push(event);
    eventsNum += 1;
  }
  return { tournamentList, tournamentMap, eventsNum };
}

/**
 * Check if we need to add sport to this tournament
 * @param {import('./interface').TMatchModel} match - current match on page
 * @param {import('./interface').TMatchModel} currEvent - current event in list
 * @param {import('./interface').TMatchModel} [prevEvent] - prev event in list if any
 * @returns 
 */
function checkSport(match, currEvent, prevEvent) {
  if (match.sportId === currEvent.sportId) {
    return false;
  }
  if (prevEvent && prevEvent.sportId === currEvent.sportId) {
    return false;
  }

  return true;
}